const BITMAP_DATA_MEMORY_CACHE = new Map<string, number>();

export const getMemoryCache = () => {
  return BITMAP_DATA_MEMORY_CACHE;
};
